import React from 'react';
import PropTypes from 'prop-types';

import isEqual from 'lodash/isEqual';

/**
 * Row component for the Table
 */
class TableRow extends React.Component {
  getEventHandlers(handlers = {}) {
    const { rowData, rowIndex, rowKey, onRowHover } = this.props;
    const eventHandlers = {};
    Object.keys(handlers).forEach(eventKey => {
      const callback = handlers[eventKey];
      if (typeof callback === 'function') {
        eventHandlers[eventKey] = event => {
          callback({ rowData, rowIndex, rowKey, event });
        };
      }
    });

    if (onRowHover) {
      const mouseEnterHandler = eventHandlers['onMouseEnter'];
      eventHandlers['onMouseEnter'] = event => {
        onRowHover({
          hovered: true,
          rowData,
          rowIndex,
          rowKey,
          event
        });
        mouseEnterHandler && mouseEnterHandler(event);
      };

      const mouseLeaveHandler = eventHandlers['onMouseLeave'];
      eventHandlers['onMouseLeave'] = event => {
        onRowHover({
          hovered: false,
          rowData,
          rowIndex,
          rowKey,
          event
        });
        mouseLeaveHandler && mouseLeaveHandler(event);
      };
    }

    return eventHandlers;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.className !== this.props.className ||
      !isEqual(nextProps.style, this.props.style) ||
      nextProps.columns !== this.props.columns ||
      nextProps.rowData !== this.props.rowData ||
      nextProps.rowIndex !== this.props.rowIndex ||
      nextProps.onRowHover !== this.props.onRowHover ||
      nextProps.rowEventHandlers !== this.props.rowEventHandlers
    );
  }

  render() {
    const {
      className,
      style,
      columns,
      rowData,
      rowIndex,
      depth,
      rootIndex,
      rowEventHandlers
    } = this.props;

    const cells = columns.map((column, columnIndex) =>
      this.props.renderCell({
        column,
        columnIndex,
        rowData,
        rowIndex,
        depth,
        rootIndex
      })
    );

    const eventHandlers = this.getEventHandlers(rowEventHandlers);
    return (
      <div className={className} style={style} {...eventHandlers}>
        {cells}
      </div>
    );
  }
}

TableRow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowData: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  depth: PropTypes.number,
  rootIndex: PropTypes.number,

  renderCell: PropTypes.func,
  onRowHover: PropTypes.func,
  rowEventHandlers: PropTypes.object
};

export default TableRow;
